import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=11ac26b9&"
import script from "./UserPreferences.vue?vue&type=script&lang=js&"
export * from "./UserPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ac26b9')) {
      api.createRecord('11ac26b9', component.options)
    } else {
      api.reload('11ac26b9', component.options)
    }
    module.hot.accept("./UserPreferences.vue?vue&type=template&id=11ac26b9&", function () {
      api.rerender('11ac26b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/UserPreferences.vue"
export default component.exports